export interface HeatmapPoint {
  time: number;
  intensity: number; // 0 to 1
}

export class HighlightEngine {
  public static async generateHeatmap(duration: number): Promise<HeatmapPoint[]> {
    console.log(`Generating engagement heatmap for duration: ${duration}s`);
    
    const points: HeatmapPoint[] = [];
    const step = duration / 20; // 20 data points for the timeline
    
    for (let i = 0; i <= 20; i++) {
      const time = i * step;
      // High intensity at start, peaks at middle/ends
      let intensity = Math.random() * 0.4 + 0.1;
      if (i === 0) intensity = 0.8;
      if (i === 10) intensity = 0.95; // Simulated highlight
      if (i === 20) intensity = 0.6;
      
      points.push({ time, intensity });
    }
    
    return points;
  }

  public static getHighlights(heatmap: HeatmapPoint[]): number[] {
    // Return times where intensity > 0.8
    return heatmap.filter(p => p.intensity > 0.8).map(p => p.time);
  }
}
